import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@/Config/api/queryKey';
import { WidgetSettingsDto } from '@/Domain/api/WIdget/dto/WidgetSetting.dto';
import { AiInsightsPage } from '@/UI/Insights/AiInsights/AiInsights.page';

export const AiInsightsLoader = () => {
  const { isLoading } = useQuery<WidgetSettingsDto>({
    queryKey: [QueryKey.widgetSettings],
  });

  if (isLoading) {
    return null;
  }

  return <AiInsightsPage />;
};
